﻿'use strict';

// #region Format checkbox input
const formatAccordionItems = document.querySelectorAll("section.js-format-accordion-item");
formatAccordionItems.forEach((formatAccordionItem) => {
    const formatCheckbox = formatAccordionItem.querySelector("input[type=checkbox].js-format-checkbox");
    const formatAccordionFieldset = formatAccordionItem.querySelector("fieldset.js-format-accordion-fieldset");
    const stashDate = formatAccordionFieldset.querySelector(".js-stash-date");
    const watchedDatesList = formatAccordionFieldset.querySelector("ul.js-watched-dates-list");
    formatCheckbox.addEventListener("click", formatCheckboxClickHandler.bind(formatCheckbox, formatAccordionItem, formatAccordionFieldset,
                                                                             stashDate, watchedDatesList));
});

function formatCheckboxClickHandler(formatAccordionItem, formatAccordionFieldset, stashDate, watchedDatesList, event) {
    const formatCheckbox = this;
    if (formatCheckbox.checked) {
        formatAccordionItem.classList.add("format-accordion-item-checked");
        formatAccordionFieldset.removeAttribute("disabled");
        formatAccordionFieldset.classList.remove("opacity-50");
    } else {
        formatAccordionItem.classList.remove("format-accordion-item-checked");
        formatAccordionFieldset.setAttribute("disabled", "");
        formatAccordionFieldset.classList.add("opacity-50");
        const hasSavedStashDate = stashDate.dataset.savedStashDate !== "";
        const hasSavedWatchDates = watchedDatesList.querySelectorAll(":scope > :not(.js-add-watch-date-list-item)").length > 0;
        if (formatCheckbox.dataset.savedFormatCheckbox.toLowerCase() === "true" &&
            (hasSavedStashDate || hasSavedWatchDates))
        {
            const alertMsg =
`Marked to be removed from your MovieStash:
• ${formatCheckbox.dataset.formatDisplayName} Format including Stash and Watch dates.`;

            alert(alertMsg);
        }
    }
}
// #endregion Format checkbox input


// #region Stash Date input
const stashDateInputs = document.querySelectorAll("input[type=date].js-stash-date");
const currentDate = new Date();
const currentDateComponents = [currentDate.getFullYear(), addLeadingZero(currentDate.getMonth() + 1), addLeadingZero(currentDate.getDate())];
const maxDateIsoString = currentDateComponents.join("-");

function addLeadingZero(monthOrDay) {
    return monthOrDay < 10 ? "0" + monthOrDay : monthOrDay;
}

stashDateInputs.forEach((stashDateInput) => {
    const savedStashDate = stashDateInput.dataset.savedStashDate;

    stashDateInput.max = maxDateIsoString;
    stashDateInput.addEventListener("input", stashDateInputHandler.bind(stashDateInput, savedStashDate));
    stashDateInput.addEventListener("blur", stashDateBlurHandler.bind(stashDateInput, savedStashDate));
});

function stashDateInputHandler(savedStashDate, event) {
    const stashDateInput = this;

    if (stashDateInput.validity.valid && savedStashDate === stashDateInput.value) {
        stashDateInput.classList.remove("format-accordion-body-date-input");
    } else {
        stashDateInput.classList.add("format-accordion-body-date-input");
        stashDateInput.reportValidity();
    }
}

function stashDateBlurHandler(savedStashDate, event) {
    const stashDateInput = this;

    if (stashDateInput.validity.valid && savedStashDate === stashDateInput.value) {
        stashDateInput.classList.remove("format-accordion-body-date-input");
    } else {
        stashDateInput.classList.add("format-accordion-body-date-input");
    }
}
// #endregion Stash Date input


// #region Watched movie card
const watchedMovieCards = document.querySelectorAll("js-watched-movie-card");
watchedMovieCards.forEach((watchedMovieCard) => {
    const newWatchDateInput = watchedMovieCard.querySelector("input[type=date].js-new-watch-date");
    newWatchDateInput.max = maxDateIsoString;
    newWatchDateInput.addEventListener("input", newWatchDateInputHandler);
    newWatchDateInput.addEventListener("blur", newWatchDateBlurHandler);

    const addWatchDateButton = watchedMovieCard.querySelector("button.js-add-watch-date-button");
    const formatId = addWatchDateButton.dataset.formatId;
    addWatchDateButton.addEventListener("click", addWatchDateButtonClickHandler.bind(addWatchDateButton, watchedMovieCard, newWatchDateInput, formatId));

    const deleteWatchDateButtons = watchedMovieCard.querySelectorAll("button.js-delete-watch-date-button");
    deleteWatchDateButtons.forEach((deleteWatchDateButton) => {
        const deleteBindingName = deleteWatchDateButton.dataset.deleteBindingName;
        deleteWatchDateButton.addEventListener("click", deleteWatchDateButtonClickHandler.bind(deleteWatchDateButton, deleteBindingName));
    });
});

function newWatchDateInputHandler(event) {
    const newWatchDateInput = this;

    if (newWatchDateInput.validity.valid && newWatchDateInput.value === "") {
        newWatchDateInput.classList.remove("format-accordion-body-date-input");
    } else {
        newWatchDateInput.classList.add("format-accordion-body-date-input");
        newWatchDateInput.reportValidity();
    }
}

function newWatchDateBlurHandler(event) {
    const newWatchDateInput = this;

    if (newWatchDateInput.validity.valid && newWatchDateInput.value === "") {
        newWatchDateInput.classList.remove("format-accordion-body-date-input");
    } else {
        newWatchDateInput.classList.add("format-accordion-body-date-input");
    }
}

function addWatchDateButtonClickHandler(watchedMovieCard, newWatchDateInput, formatId, event) {
    const addWatchDateButton = this;

    if (!newWatchDateInput.validity.valid) {
        newWatchDateInput.reportValidity();
        return;
    } else if (newWatchDateInput.value === "") {
        newWatchDateInput.classList.remove("format-accordion-body-date-input");
        return;
    }

    const newWatchDateComponents = newWatchDateInput.value.split("-");
    const newWatchDateString = [newWatchDateComponents[1], newWatchDateComponents[2], newWatchDateComponents[0]].join("/");

    // NOTE when changing any of the markup in this li, do the same in FormatAccordion/Default.cshtml
    const newWatchDateListItemHtml = // html
        `<li class="list-group-item d-flex align-items-center js-watch-date-list-item js-add-watch-date-list-item">
            <svg width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill text-success me-2" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
            </svg>
            ${newWatchDateString}
            <input type="hidden" name="format-accordion[${formatId}].AddWatchDates" value="${newWatchDateString}">
            <button type="button" class="ms-auto btn btn-outline-danger-lightness--5-saturation--5 py-1 px-2 lh-1 d-flex js-delete-watch-date-button"
                    aria-label="Remove watch date">
                <svg width="16" height="16" fill="currentColor" class="bi bi-x-square me-1" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                Remove
            </button>
        </li>`;

    const watchedDatesList = watchedMovieCard.querySelector(".js-watched-dates-list");
    watchedDatesList.insertAdjacentHTML("afterbegin", newWatchDateListItemHtml);

    const addWatchDates = watchedDatesList.querySelectorAll(":scope > .js-add-watch-date-list-item");
    if (addWatchDates.length === 1 && watchedDatesList.children.length > 1) {
        watchedDatesList.firstElementChild.classList.add("last-add-watch-date-list-item");
    }

    const deleteWatchDateButton = watchedDatesList.firstElementChild.querySelector("button.js-delete-watch-date-button");
    deleteWatchDateButton.addEventListener("click", deleteWatchDateButtonClickHandler.bind(deleteWatchDateButton, null));

    const pendingDatesTip = watchedMovieCard.querySelector("p.js-pending-dates-tip");
    pendingDatesTip.classList.remove("visually-hidden");

    // clear new watch date input
    newWatchDateInput.value = "";
    newWatchDateInput.classList.remove("format-accordion-body-date-input");
}

function deleteWatchDateButtonClickHandler(deleteBindingName, event) {
    const deleteWatchDateButton = this;
    const watchDateListItem = deleteWatchDateButton.closest(".js-watch-date-list-item");
    const watchedDatesList = watchDateListItem.closest(".js-watched-dates-list");

    if (watchDateListItem.classList.contains("js-add-watch-date-list-item")) {
        // remove new watch date
        deleteWatchDateButton.removeEventListener("click", deleteWatchDateButtonClickHandler);
        const previousWatchDateListItem = watchDateListItem.previousElementSibling;
        if (watchDateListItem.classList.contains("last-add-watch-date-list-item") && previousWatchDateListItem !== null) {
            previousWatchDateListItem.classList.add("last-add-watch-date-list-item");
        }
        watchDateListItem.remove();
    } else if (watchDateListItem.classList.contains("js-delete-watch-date-list-item")) {
        // undo mark for watch date to be removed
        const deleteWatchDateIcon = watchDateListItem.querySelector("svg.js-delete-watch-date-icon");
        deleteWatchDateIcon.classList.add("invisible");
        
        watchDateListItem.classList.remove("js-delete-watch-date-list-item");
        const hiddenWatchDate = watchDateListItem.querySelector(".js-hidden-watch-date");
        hiddenWatchDate.removeAttribute("name");
    } else {
        // mark watch date to be removed
        const deleteWatchDateIcon = watchDateListItem.querySelector("svg.js-delete-watch-date-icon");
        deleteWatchDateIcon.classList.remove("invisible");

        watchDateListItem.classList.add("js-delete-watch-date-list-item");
        const hiddenWatchDate = watchDateListItem.querySelector(".js-hidden-watch-date");
        hiddenWatchDate.setAttribute("name", deleteBindingName);
    }

    const pendingDatesTip = watchedDatesList.closest(".js-watched-movie-card").querySelector(".js-pending-dates-tip");
    if (watchedDatesList.querySelector(".js-add-watch-date-list-item") != null
        || watchedDatesList.querySelector(".js-delete-watch-date-list-item") != null) {
        pendingDatesTip.classList.remove("visually-hidden");
    } else {
        pendingDatesTip.classList.add("visually-hidden");
    }
}
// #endregion Watched movie card
